import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { DollarSign, TrendingUp, TrendingDown } from 'lucide-react';
import axios from 'axios';

import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

const PortfolioSummary = ({ walletAddress }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSummary();
    const interval = setInterval(fetchSummary, 30000); // Обновлять каждые 30 секунд
    return () => clearInterval(interval);
  }, [walletAddress]);

  const fetchSummary = async () => {
    try {
      const params = walletAddress ? { wallet_address: walletAddress } : {};
      const response = await axios.get(`${API_URL}/api/portfolio/summary`, { params });
      if (response.data.success) {
        setSummary(response.data.summary);
      }
    } catch (error) {
      console.error('Error fetching portfolio summary:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!summary) {
    return <div>No data available</div>;
  }

  const isProfit = summary.total_pnl_usd >= 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Invested</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{summary.total_invested_ton.toFixed(2)} TON</div>
          <p className="text-xs text-muted-foreground">
            ${summary.total_invested_usd.toFixed(2)} USD
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Current Value</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{summary.current_value_ton.toFixed(2)} TON</div>
          <p className="text-xs text-muted-foreground">
            ${summary.current_value_usd.toFixed(2)} USD
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total P&L</CardTitle>
          {isProfit ? (
            <TrendingUp className="h-4 w-4 text-green-600" />
          ) : (
            <TrendingDown className="h-4 w-4 text-red-600" />
          )}
        </CardHeader>
        <CardContent>
          <div className={`text-2xl font-bold ${isProfit ? 'text-green-600' : 'text-red-600'}`}>
            {isProfit ? '+' : ''}{summary.total_pnl_ton.toFixed(2)} TON
          </div>
          <p className={`text-xs ${isProfit ? 'text-green-600' : 'text-red-600'}`}>
            {isProfit ? '+' : ''}${summary.total_pnl_usd.toFixed(2)} USD
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">ROI</CardTitle>
          {isProfit ? (
            <TrendingUp className="h-4 w-4 text-green-600" />
          ) : (
            <TrendingDown className="h-4 w-4 text-red-600" />
          )}
        </CardHeader>
        <CardContent>
          <div className={`text-2xl font-bold ${isProfit ? 'text-green-600' : 'text-red-600'}`}>
            {isProfit ? '+' : ''}{summary.roi_percent.toFixed(2)}%
          </div>
          <p className="text-xs text-muted-foreground">
            {summary.positions_count} positions
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PortfolioSummary;


